export function setStorage(key, data) {
  if (data !== null && typeof data === 'object') {
    return localStorage.setItem(key, JSON.stringify(data))
  }
  localStorage.setItem(key, data)
}

export function getStorage(key, defaultValue) {
  const result = localStorage.getItem(key)
  if ((result?.startsWith('{') && result?.endsWith('}')) || (result?.startsWith('[') && result?.endsWith(']'))) {
    return JSON.parse(result)
  }
  if (result === 'true') return true
  if (result === 'false') return false
  return result === 'null' || result === null ? defaultValue : result
}

export function removeStorage(key) {
  localStorage.removeItem(key)
}

const BaseStorage = {
  set(value = '', key) {
    setStorage(key || this.key, value)
  },
  get(key, defaultValue) {
    return getStorage(key || this.key, defaultValue)
  },
  clear(key) {
    removeStorage(key || this.key)
  },
}

// 缓存 TabsBar
export const TabsBarStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_TABS_BAR',
})

// 缓存用户信息
export const UserStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_USER_INFO',
})

// 是否需要修改密码
export const ChangePwdStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_IS_CHANGE_PWD',
})

// token
export const TokenStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_X_TOKEN',
})

// token
export const ShopTokenStorage = Object.assign(Object.create(BaseStorage), {
  key: 'X-SHOP-TOKEN',
})

// webfunny
export const WebFunnyStorage = Object.assign(Object.create(BaseStorage), {
  key: 'wmUserInfo',
})

// 国际化
export const LocaleStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_LANG',
  get(key, defaultValue = 'zh-CN') {
    return getStorage(key || this.key, defaultValue)
  },
})

// 版本号
export const AppVersionStorage = Object.assign(Object.create(BaseStorage), {
  key: 'DH_APP_VERSION',
})

// 门店信息
export const ShopInfoStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_SHOP_INFO',
})

// 门店信息
export const UidStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_UUID',
})

// 设置
export const SettingStorage = Object.assign(Object.create(BaseStorage), {
  key: 'SETTING',
})

// 预收银单号
export const PreOrderStorage = Object.assign(Object.create(BaseStorage), {
  key: 'PREORDER',
})

// 记住密码
export const RememberPassword = Object.assign(Object.create(BaseStorage), { key: 'REMEMBER_PASSWORD' })

// 账号信息
export const AccountInfo = Object.assign(Object.create(BaseStorage), { key: 'ACCOUNT_INFO' })
// 软件信息
export const AppInfoStorage = Object.assign(Object.create(BaseStorage), { key: 'DH_POS_APP_INFO' })
// 外卖打印设置
export const TakeawayPrintSetting = Object.assign(Object.create(BaseStorage), { key: 'TAKEAWAY_PRINT_SETTING' })

// 编辑态草稿
export const DarftData = Object.assign(Object.create(BaseStorage), { key: 'DARFT_DATA' })
